/**
 * Support contact details.
 *
 * The address was duplicated across AssociationSuspended, SignIn and the docs
 * pages; this is the one definition.
 *
 * The in-app contact page is not reachable everywhere: `/contact` sits behind
 * AuthGuard and posts through the authenticated axios instance, so a visitor
 * who is still registering cannot use it. They go to the public contact page
 * instead.
 */
export const SUPPORT_EMAIL = "asiakaspalvelu@tiehoitokunta.fi";
export const SUPPORT_URL = "https://tiehoitokunta.fi/yhteys";

export interface RoadProblemReport {
  municipality?: string | null;
  roadName?: string | null;
  /** WGS84 [lon, lat] of the point the user clicked, when there was one. */
  lngLat?: [number, number] | null;
  /** The road register's own error text, verbatim. */
  apiError?: string | null;
}

/**
 * The details support needs to diagnose a road that cannot be registered.
 *
 * The contact page cannot be prefilled the way a mailto could, so these are
 * shown to the user instead — otherwise the report arrives as "it doesn't
 * work" and costs a round trip. Only the fields we actually have are listed,
 * so the user is never asked to relay a dash.
 */
export const describeRoadProblem = (
  report: RoadProblemReport
): { label: string; value: string }[] => {
  const rows: { label: string; value: string }[] = [];

  if (report.municipality)
    rows.push({ label: "Kunta", value: report.municipality });
  if (report.roadName)
    rows.push({ label: "Tien nimi", value: report.roadName });
  if (report.lngLat) {
    rows.push({
      label: "Sijainti",
      value: `${report.lngLat[1].toFixed(5)}, ${report.lngLat[0].toFixed(5)}`,
    });
  }
  if (report.apiError) {
    rows.push({ label: "Tierekisterin virhe", value: report.apiError });
  }

  return rows;
};

/** In-app route for the public support form. */
export const SUPPORT_PATH = "/tuki";
